/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Chat Property that is used for filtering.
 *
 */
export var ChatPropertyForFiltering;
(function (ChatPropertyForFiltering) {
    ChatPropertyForFiltering["CHAT_ID"] = "chatId";
    ChatPropertyForFiltering["CHAT_TITLE"] = "chatTitle";
})(ChatPropertyForFiltering || (ChatPropertyForFiltering = {}));
